module.exports = __webpack_public_path__ + "img/bim (2).7607e672.png";